export default __webpack_public_path__ + "static/img3-c10b4c9e084061412408d5d566e52e69.png";